import { render, staticRenderFns } from "./CustomerPropertyCreationPopup.vue?vue&type=template&id=54878b4e&scoped=true&"
import script from "./CustomerPropertyCreationPopup.vue?vue&type=script&lang=js&"
export * from "./CustomerPropertyCreationPopup.vue?vue&type=script&lang=js&"
import style0 from "./CustomerPropertyCreationPopup.vue?vue&type=style&index=0&id=54878b4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54878b4e",
  null
  
)

export default component.exports